import { storage } from "firebase";

export function createSamplingImageKey(samplingResultId: string, filename: string): string {
    return `sampling/${samplingResultId}/${filename}`;
}

export function createAnalysisImageKey(analysisResultId: string, filename: string): string {
    return `analysis/${analysisResultId}/${filename}`;
}

export function createWarrantyImageKey(warrantyId: string, filename: string): string {
    return `AQ Scope Soil Warranty/${filename}`;
}

export async function tryGetDownloadUrl(storageRef: storage.Reference, key: string): Promise<string|null> {
    try {
        return await (storageRef.child(key).getDownloadURL()) as string;
    } catch (e) {
        console.error(e);
        return null;
    }
}
